import { createSelector } from 'selectors'
import { editor } from './constant'

const getConcreteComponentSelector = (scope: HTMLElement, componentSelector: string) =>
	createSelector<HTMLSelectElement>({ scope, selector: componentSelector })

const getEditorComponents = () =>
	createSelector<NodeListOf<HTMLElement>>({ selector: editor.editorComponentContainer }, true)

const getEditorSaveComponent = () => createSelector<HTMLElement>({ selector: editor.editorSaveButton })
const getEditorErrorComponent = () => createSelector<HTMLElement>({ selector: editor.editorError })

export const getEditorConcreteComponent = (componentSelector: string) => {
	const scopes = getEditorComponents()
	if (!scopes) return null

	let concreteComponent = null
	for (let i = 0; i < scopes.length; i++) {
		concreteComponent = getConcreteComponentSelector(scopes[i], componentSelector)
		if (concreteComponent) break
	}

	return concreteComponent
}

export const getEditorSaveComponents = () => ({
	editorSubmitButton: getEditorSaveComponent(),
	editorErrorDiv: getEditorErrorComponent(),
})
